var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnInit, OnDestroy } from '@angular/core';
import { environment } from '@environments/environment';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { INDRABookingService } from '@ibe.services/booking.indra.service';
import { ModalService, SidebarService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import * as Moment from 'moment';
import { extendMoment } from 'moment-range';
import { FeaturesMap } from '@ibe.models/flight.model.lib';
import { brandExtraFeature } from '@ibe.components/booking/flights/brand/brand';
import { ANCILLARY_PRODUCT_PACKS } from '@ibe.config';
var moment = extendMoment(Moment);
var INDRAPackModalComponent = /** @class */ (function (_super) {
    __extends(INDRAPackModalComponent, _super);
    function INDRAPackModalComponent(bookingService, store, modalService, sidebarService) {
        var _this = _super.call(this, modalService) || this;
        _this.bookingService = bookingService;
        _this.store = store;
        _this.modalService = modalService;
        _this.sidebarService = sidebarService;
        _this.isAlive = true;
        _this.extra_features = [];
        _this.bundle_features = [];
        _this.available_bundles = [];
        _this.activeBookedTrip = null;
        moment.locale(environment.locale);
        return _this;
    }
    INDRAPackModalComponent.prototype.ngOnInit = function () {
        this.bundle = this.data[0].bundle;
        this.flight = this.data[0].flight;
        this.selectedExtra = this.data[0].selectedExtra;
        this.INDRA_setUpFlights();
        this.INDRA_setExtrasData();
    };
    INDRAPackModalComponent.prototype.INDRA_setUpFlights = function () {
        this._flight = this.flight;
    };
    INDRAPackModalComponent.prototype.INDRA_setExtrasData = function () {
        var _this = this;
        this.extra = this.bundle.extras_availables.find(function (e) { return e.id == _this.selectedExtra; });
        this.bundle_features = Object.assign([], this.bundle.INDRA_getPacksbyExtra(this.extra));
        this.bundle_features.forEach(function (bundle) {
            if (_this.INDRA_packSegmentsAvailable(bundle)) {
                _this.available_bundles.push(bundle);
            }
        });
        if (this.available_bundles.length === 0) {
            this.INDRA_handleOpenExtra(this.extra);
        }
    };
    INDRAPackModalComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
    };
    INDRAPackModalComponent.prototype.INDRA_close = function () {
        this.closeModal();
    };
    INDRAPackModalComponent.prototype.INDRA_getCardStyles = function () {
        return {
            'modal-pack': true,
            'single-pack': this.available_bundles && this.available_bundles.length == 1,
        };
    };
    INDRAPackModalComponent.prototype.INDRA_handleOpenPack = function (pack) {
        this.INDRA_close();
        this.sidebarService.openSidebar(["packs", { flight: this._flight.details.assignedFlightId, packId: this.getPackCode(pack) }]);
    };
    INDRAPackModalComponent.prototype.INDRA_handleOpenExtra = function (feature) {
        this.INDRA_close();
        this.sidebarService.openSidebar([feature.action.route, { flight: this._flight.details.assignedFlightId, purchased: this.featureCountAdded(feature) }]);
    };
    INDRAPackModalComponent.prototype.featureCountAdded = function (feature) {
        return this.bookingNotification === 'purchase-completed' && feature.type === 'extra' && new FeaturesMap(this._flight).getCountAdded(feature);
    };
    INDRAPackModalComponent.prototype.INDRA_printImage = function () {
        var IMAGE = 'arrow-bundle-card.svg';
        return 'url(assets/images/ancillaries/packs/' + IMAGE + ')';
    };
    INDRAPackModalComponent.prototype.getPackCode = function (pack) {
        return pack.ancillaryList[0].catalog[0].passengers[0].codeList[0].code;
    };
    INDRAPackModalComponent.prototype.INDRA_packSegmentsAvailable = function (pack) {
        var _this = this;
        var availableSegments = [];
        var availableBundleCodes = [this.selectedExtra];
        this.bundle_features.forEach(function (bundle) {
            availableBundleCodes.push(bundle.ancillaryList[0].type);
        });
        if (pack.ancillaryList[0].catalog && pack.ancillaryList[0].catalog.length) {
            var addedFeatures_1 = this.bundle.features_added.filter(function (feature) { return availableBundleCodes.includes(feature.code); });
            var ancillariesInPack_1 = [];
            pack.ancillaryList[0].catalog[0].passengers[0].codeList[0].ancillaryPackInfo.ancillaryDescription.forEach(function (anc) {
                ancillariesInPack_1.push(anc.code);
            });
            var addedPackAncillaries_1 = [];
            if (this.bundle.features_added && this.bundle.features_added.length) {
                this.bundle.features_added.forEach(function (feature) {
                    if (ANCILLARY_PRODUCT_PACKS.includes(feature.code)) {
                        // Feature added is pack, so must compare ancillaries to theck is pack is available
                        var addedPack_1 = _this.bundle.bundle_features.find((function (bundle) { return bundle.ancillaryList[0].type === feature.code; }));
                        var addedSegments_1 = [];
                        addedPack_1.ancillaryList[0].catalog.forEach(function (catalog) {
                            if (_this.bundle.features_added.find(function (bundle) { return (bundle.code === addedPack_1.ancillaryList[0].type) && (bundle.segmentId == catalog.segmentId); })) {
                                addedSegments_1.push(catalog);
                            }
                        });
                        addedSegments_1.forEach(function (segment) {
                            segment.passengers[0].codeList[0].ancillaryPackInfo.ancillaryDescription.forEach(function (anc) {
                                addedPackAncillaries_1.push({
                                    segmentId: segment.segmentId,
                                    flightId: segment.flightId,
                                    code: anc.code
                                });
                            });
                        });
                    }
                });
            }
            pack.ancillaryList[0].catalog.forEach(function (catalog) {
                if (!addedFeatures_1.find(function (feature) { return catalog.segmentId === feature.segmentId; })) {
                    availableSegments.push(catalog);
                }
                // Check ancillaries in added packs to see if current pack is available
                availableSegments.forEach(function (segment, index) {
                    segment.passengers[0].codeList[0].ancillaryPackInfo.ancillaryDescription.forEach(function (anc) {
                        if (addedPackAncillaries_1.find(function (feature) { return (feature.code === anc.code && feature.segmentId === segment.segmentId) || (feature.flightId !== segment.flightId); })) {
                            availableSegments.splice(index, 1);
                        }
                    });
                });
            });
        }
        if (availableSegments.length) {
            return true;
        }
        else {
            return false;
        }
    };
    INDRAPackModalComponent.prototype.INDRA_getPackSegments = function (bundle) {
        var _this = this;
        var type;
        if (bundle.ancillaryList[0]) {
            type = bundle.ancillaryList[0].type;
        }
        var packsPerSegment = [];
        this.bundle_features.forEach(function (pack) {
            if (pack.ancillaryList[0].type === type) {
                if (pack.ancillaryList[0].catalog) {
                    pack.ancillaryList[0].catalog.forEach(function (catalog) {
                        if (catalog.flightId == _this.flight.details.idFlight.toString()) {
                            packsPerSegment.push(__assign({}, catalog, { itemId: pack.ancillaryList[0].itemId, type: pack.ancillaryList[0].type }));
                        }
                    });
                }
            }
        });
        return packsPerSegment;
    };
    return INDRAPackModalComponent;
}(AbstractModalContentComponent));
export { INDRAPackModalComponent };
